import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://2eaaf7ea7b97acaf71770ae0bd247d78@o4509163070685184.ingest.de.sentry.io/4509163301044304",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
});
